import {post} from '@/utils/axios'

class SoftwareModel {

    // 官网获取软件资源
    async getAllSoftware() {
        return post('/v1/software/getAllSoftware')
    }

    /**
     * 获取软件详细信息
     * @param softwareName 软件名
     * @returns {Promise<*>}
     */
    async getSoftwareInfo(softwareName, softwareSystem) {
        return post('/v1/software/getSoftwareInfo', {
            softwareName,
            softwareSystem
        })
    }

    /**
     * 获取软件详细信息
     * @param softwareName 软件名
     * @returns {Promise<*>}
     */
    async getSoftwareInfoList(softwareName, softwareType) {
        return post('/v1/software/getSoftwareInfoList', {
            softwareName,
            softwareType
        })
    }

    /**
     * 增加下载次数
     * @param softwareName 软件名
     * @returns {Promise<*>}
     */
    async softwareTimes(softwareName) {
        return post('/v1/software/softwareTimes', {
            softwareName
        })
    }

    softwareTypeList =  {
            0: '移动端',
            1: '设备端',
            3: '插件',
			4: '快应用',
    }

     softwareSystemList =  {
            0: 'Android',
            1: 'IOS',
            2: 'Windows',
            3: 'Mac'
        }
}

export default new SoftwareModel()
